export const oneDayInMilliseconds = 24 * 3600 * 1000;
